import {createContext} from 'react';

const UserSecretsContext = createContext(null);

export default UserSecretsContext;
